import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import { ApolloResponse } from '@/interfaces/apollo'
import { getCandidateBooks } from '@/modules/Book/gql/book.gql'
import { Book } from '@/modules/Book/interfaces/book'
import { showErrors } from '@/utils/snack'

@Component
export default class SearchBook extends Vue {
  candidatesBook: Book[] = []

  get candidatesBookOptions () {
    return this.candidatesBook.map(item => {
      return {
        id: +item.id,
        name: item.name
      }
    })
  }

  async mounted () {
    this.getCandidateBooks()
  }

  async getCandidateBooks (val?: string) {
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getCandidateBooks,
        variables: {
          filter: {
            name: val
          },
          paging: {
            offset: 0,
            limit: -1
          }
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.candidatesBook = this.$R.sortBy(this.$R.compose(this.$R.toLower, this.$R.prop('name')))(result.data.getBooks.books)
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }
}
